// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q6-9";
export var arrowButtonContainer = "_q6-5";
export var arrowButtonIcon = "_q6-6";
export var carouselArrowButton = "_q6-2";
export var carouselElementContainer = "_q6-1";
export var currentSlide = "_q6-8";
export var left = "_q6-3";
export var otherSlide = "_q6-a";
export var productCarouselContainer = "_q6-0";
export var right = "_q6-4";
export var sliderOverflow = "_q6-7";